import styled, { CSSProperties } from "styled-components";
import { Space, Button as ButtonBase } from "antd";

export const PageHeader = styled(Space)`
  margin-bottom: 1.5em;
  width: 100%;
`;

export const Container = styled(Space)`
  width: 100%;
`;

export const PageTitle = styled.div`
  font-size: 24px;
`;

export const Button = styled(ButtonBase)`
  padding: 0;
`;

export const MapContainer = styled.div<{ height: CSSProperties["height"] }>`
  height: ${({ height }) => height};
  display: flex;
  align-items: center;
  justify-content: center;
`;
